import { render, staticRenderFns } from "./ProfileGuardianHeader.vue?vue&type=template&id=23d53738&scoped=true&"
import script from "./ProfileGuardianHeader.vue?vue&type=script&lang=ts&"
export * from "./ProfileGuardianHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d53738",
  null
  
)

export default component.exports